import { AppSession } from '../../domain/models/AppSession';
import { SessionLocalRepo } from '../../domain/repositories/SessionLocalRepo';
import { applog } from '../../domain/utils/applog';

export class SessionCache implements SessionLocalRepo {

    private ip: String = '';
    lat?:number;
    lng?:number;



    setIp(ip: String) {
        this.ip = ip;
    }

    getIp() {
        applog("Returning IP from RAM Cache");
        return this.ip;
    }

    setSession(session: AppSession) {
        localStorage.setItem("session", JSON.stringify(session));
    }
    getSession(): AppSession | null {
        const json = localStorage.getItem("session");
        if (json != null) {
            return JSON.parse(json);
        } else {
            return null;
        }
    }
    clearSession() {
        localStorage.clear();
    }
}